/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const a=(a=>a)(["operational-layers","basemap","ground"]);export{a as excludeTables};
